import React from 'react';
import { EmailLeadFormModal } from '@dmm/lib-react-ui-components';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { useBdpForm } from '../MainContent/bdpController/useBdpForm';
import { nil } from '../../../utils/runOnceHelper';
import { bdpFormMessages } from '../utils/bdpParsers';
import {syncTranslationElements} from '../../../tppServices/translations/intlManager';
import { BREAKPOINTS } from '../../../utils/commonHelper';

const DisplayedLeadFormModal = ({
  onClose,
  intl,
  listing,
  portal,
  onSuccess,
  onError,
  featureFlagQuestionnaire,
  breakpoint,
  shouldConvertCustomLeadHygieneGoal,
  yearMakeModel,
  showSubjectDropdown
}) => {
  const leadTranslate = syncTranslationElements(intl);
  const idPrefix = 'modal-lead-form-';
  const showCloseButton = true;
  const { leadFormFields, leadFormHandlers, invalidFields, isDisabled, selectedCountry, flagsWithPrefix, onChangeSubject, formSubjects, defaultSubject } = useBdpForm(
    listing,
    portal,
    leadTranslate,
    idPrefix,
    onSuccess,
    onError,
    yearMakeModel,
    showCloseButton,
  );

  const { sellerNameField, nameField, emailField, phoneField, textField } = leadFormFields;
  const { handleSubmit, showSuccess, showError } = leadFormHandlers;
  const { messages, t } = leadTranslate;
  const isManufacturer = listing?.isOemModel;
  const emailFormMessages = bdpFormMessages(t, messages, isManufacturer);
  const doClose = () => {
    onClose();
  };
  const onSubmitLeadHygieneExperiment = () => {
    handleSubmit(shouldConvertCustomLeadHygieneGoal);
  };

  return (
    <div className={`email-lead-form-modal${breakpoint !== BREAKPOINTS.desktop ? '-mobile' : ''}`}>
      <EmailLeadFormModal
        onClose={doClose}
        sellerName={sellerNameField}
        name={nameField}
        email={emailField}
        phone={phoneField}
        textarea={textField}
        buttonDisabled={isDisabled}
        invalidFields={invalidFields}
        invalidMessage={`* ${t(messages.contactForm.formError)}`}
        showSuccessMessage={showSuccess}
        showErrorMessage={showError}
        onSubmit={onSubmitLeadHygieneExperiment}
        leadHygieneModalHeaderText= {isManufacturer ? t(messages.contactForm.title) : t(messages.contactForm.contactButton)}
        classNames={{
          leadHygieneModal: true,
          countryPhoneModal: true,
          leadQualityModal: featureFlagQuestionnaire,
          showSubjectDropdown: showSubjectDropdown
        }}
        countries={flagsWithPrefix}
        countrySelected={selectedCountry}
        searchText={t(messages.contactForm.countrySearch)}
        noResultsText={t(messages.contactForm.countrySearchEmpty)}
        {...emailFormMessages}
        subjectLabel={t(messages.contactForm.subjectLabel)}
        subjectDefaultText={defaultSubject}
        subjects={formSubjects}
        onChangeSubject={onChangeSubject}
      />
    </div>
  );

};

const BDPEmailLeadFormModal = ({
  portal,
  onClose,
  intl,
  listing,
  onSuccess = nil,
  onError = nil,
  featureFlagQuestionnaire,
  breakpoint,
  shouldConvertCustomLeadHygieneGoal,
  yearMakeModel,
  showSubjectDropdown = true
}) => {
  return (
    <DisplayedLeadFormModal
      onClose={onClose}
      intl={intl}
      listing={listing}
      portal={portal}
      onSuccess={onSuccess}
      onError={onError}
      breakpoint={breakpoint}
      shouldConvertCustomLeadHygieneGoal={shouldConvertCustomLeadHygieneGoal}
      featureFlagQuestionnaire={featureFlagQuestionnaire}
      yearMakeModel={yearMakeModel}
      showSubjectDropdown={showSubjectDropdown}
    />
  );
};

const EmailModalPropTypes = {
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    locale: PropTypes.string
  }).isRequired,
  listing: listingPropTypes.isRequired,
  portal: PropTypes.string,
  shouldConvertCustomLeadHygieneGoal: PropTypes.bool,
};

BDPEmailLeadFormModal.propTypes = {
  ...EmailModalPropTypes,
  show: PropTypes.bool
};
DisplayedLeadFormModal.propTypes = {
  ...EmailModalPropTypes
};

export default injectIntl(BDPEmailLeadFormModal);
